/* eslint-disable react/prop-types */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 14
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const formatAmount = (amount) => new Intl.NumberFormat().format(amount);

export default function ProcessorReportTable({ rows }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Processors</StyledTableCell>
            <StyledTableCell align="right">Success</StyledTableCell>
            <StyledTableCell align="right">Amount</StyledTableCell>

            <StyledTableCell align="right">Failed</StyledTableCell>
            <StyledTableCell align="right">Amount</StyledTableCell>

            <StyledTableCell align="right">Total</StyledTableCell>
            <StyledTableCell align="right">Amount</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell component="th" scope="row">
                {row.processor}
              </StyledTableCell>
              <StyledTableCell align="right">{row.success}</StyledTableCell>
              <StyledTableCell align="right">₦{formatAmount(row.successAmount)}</StyledTableCell>

              <StyledTableCell align="right">{row.failed}</StyledTableCell>
              <StyledTableCell align="right">₦{formatAmount(row.failedAmount)}</StyledTableCell>

              <StyledTableCell align="right">{row.totalCount}</StyledTableCell>
              <StyledTableCell align="right">₦{formatAmount(row.totalAmount)}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
